import { Card, Col, Modal, Row, Switch } from 'antd';

import { i18, trb } from '../../Utilities';
import { AlertNotification, Typography } from '../../shared';
import { useApiVOP } from '../../api';
import { ContentLoader } from '../../Components';

export const SettingsAccount = () => {
  const [modal, contextHolder] = Modal.useModal();
  const { data, isFetching, isRefetching, refetch } = useApiVOP.getBulkStatus();
  const { mutateAsync, isPending } = useApiVOP.postBulkStatus();

  const handleChangeVOPBulk = (checked: boolean) => {
    modal.confirm({
      title: trb('AccountSettings.ModalTitles_ChangeVOPInBulkPayments'),
      content: (
        <div dangerouslySetInnerHTML={{ __html: trb(`AccountSettings.${checked ? 'ModalsContents_ChangeVOPInBulkPaymentsOn' : 'ModalsContents_ChangeVOPInBulkPaymentsOff'}`) }} />
      ),
      okText: trb('Common.Buttons_Confirm'),
      cancelText: trb('Common.Buttons_Cancel'),
      centered: true,
      closable: true,
      onOk: async () => {
        try {
          await mutateAsync(checked);
          await refetch();
        } catch (e) {
          // Error handled by react-query
        }
      },
    });
  };

  return (
    <div>
      {contextHolder}
      <div className="eb_content_subtitle">{trb(i18.ContentTitles.SettingsAccount)}</div>
      <Card
        style={{ padding: 16 }}
        styles={{ body: { width: '100%', display: 'block' } }}
      >
        {data?.VopEnabled === false && (
          <AlertNotification
            message={trb('AccountSettings.Labels_VOPDisabled')}
            type="error"
            alertClassName="py-3 mb-3"
          />
        )}
        <AlertNotification
          message={trb('AccountSettings.Labels_Settings')}
          type="info"
          alertClassName="py-3 mb-3"
        />
        {isFetching && isRefetching ? (
          <ContentLoader />
        ) : (
          <>
            <div className="bbs_settings_card">
              <Row
                gutter={[16, 0]}
                wrap={false}
              >
                <Col flex="auto">
                  <Typography.Text>{trb('AccountSettings.Labels_VOPInBulkPayments')}</Typography.Text>
                </Col>
                <Col flex="none">
                  <Switch
                    loading={isPending || isFetching}
                    checked={data?.VopClientEnabled}
                    onChange={(checked) => handleChangeVOPBulk(checked)}
                    disabled={!data?.VopEnabled}
                  />
                </Col>
              </Row>
            </div>
          </>
        )}
      </Card>
    </div>
  );
};
